export const SHOW_SETTINGS_PAGE = "SHOW_SETTINGS_PAGE";
export const HIDE_SETTINGS_PAGE = "HIDE_SETTINGS_PAGE";
export const TURN_ON_CAMERA = "TURN_ON_CAMERA";
export const TURN_OFF_CAMERA = "TURN_OFF_CAMERA";
export const TURN_ON_MIC = "TURN_ON_MIC";
export const TURN_OFF_MIC = "TURN_OFF_MIC";
export const SET_PASS_LOGIN = "SET_PASS_LOGIN";
export const SHOW_ATTENDEE_COUNT = "SHOW_ATTENDEE_COUNT";
export const SET_READY_RECORD = "SET_READY_RECORD";
export const SET_OFF_RECORD = "SET_OFF_RECORD";
export const SET_START_RECORD = "SET_START_RECORD";
export const TURN_OFF_HOST_CAMERA = "TURN_OFF_HOST_CAMERA";
export const TURN_ON_HOST_CAMERA = "TURN_ON_HOST_CAMERA";
export const TURN_OFF_HOST_MIC = "TURN_OFF_HOST_MIC";
export const TURN_ON_HOST_MIC = "TURN_ON_HOST_MIC";
export const SET_UID = "SET_UID";
export const SET_COPRESENTER_UIDS = "SET_COPRESENTER_UIDS";
export const SET_COPRESENTER_INFO = "SET_COPRESENTER_INFO";
export const SET_ROLE_COPRESENTER = "SET_ROLE_COPRESENTER";
export const SET_IS_SHOW_ATTENDEE_LIST = "SET_IS_SHOW_ATTENDEE_LIST";
export const CHECK_RECORD = "CHECK_RECORD";
export const OFF_CHECK_RECORD = "OFF_CHECK_RECORD";
export const TURN_ON_SCREEN_SHARING = "TURN_ON_SCREEN_SHARING";
export const TURN_OFF_SCREEN_SHARING = "TURN_OFF_SCREEN_SHARING";
export const TURN_ON_SCREEN_SHARING_TOAST = "TURN_ON_SCREEN_SHARING_TOAST";
export const TURN_OFF_SCREEN_SHARING_TOAST = "TURN_OFF_SCREEN_SHARING_TOAST";
export const TOAST_MESSAGE = "TOAST_MESSAGE";
export const COPRESENTINFO = "COPRESENTINFO";
export const MUTECOPRESENTERUID = "MUTECOPRESENTERUID";
export const MUTEDBYHOST = "MUTEDBYHOST";
export const SET_CAM_BEFORE_SCREEN_SHARE = "SET_CAM_BEFORE_SCREEN_SHARE";
export const CHANGEVIDEO = "CHANGEVIDEO";
export const CHANGEAUDIO = "CHANGEAUDIO";
export const USEPORTRAIT = "USEPORTRAIT";
export const SET_ROTATE_DEGREE = "SET_ROTATE_DEGREE";
export const SET_PINNED_LAYOUT_UID = "SET_PINNED_LAYOUT_UID";